export enum FBUploadActionTypes {
  SET_SETTINGS_TYPE = 'SET_SETTINGS_TYPE',
  SET_MENU_ITEM_AT_BUNDLE_MODAL = 'SET_MENU_ITEM_AT_BUNDLE_MODAL',
}

interface ISetSettingsTypeAction {
  type: FBUploadActionTypes.SET_SETTINGS_TYPE;
  payload: string;
}
interface ISetMenuItemAtBundleModalAction {
  type: FBUploadActionTypes.SET_MENU_ITEM_AT_BUNDLE_MODAL;
  payload: string;
}

export type TFBUploadActions = ISetSettingsTypeAction | ISetMenuItemAtBundleModalAction;

export const setUploadSettingsType = (payload: string): TFBUploadActions => ({
  type: FBUploadActionTypes.SET_SETTINGS_TYPE,
  payload,
});

export const setMenuItemAtBundleModal = (payload: string): TFBUploadActions => ({
  type: FBUploadActionTypes.SET_MENU_ITEM_AT_BUNDLE_MODAL,
  payload,
});
